import {
  GET_JURISDICTIONS_REQUEST,
  GET_JURISDICTIONS_SUCCESS,
  GET_JURISDICTIONS_FAILED,
  DELETE_JURISDICTION_REQUEST,
  DELETE_JURISDICTION_SUCCESS,
  DELETE_JURISDICTION_FAILED,
} from './actionTypes';

const initialState = {
  data: [],
  page: 1,
  lastPage: 1,
  loading: false,
  error: null,
  search: '',
  sort: null,
  order: null,
  perPage: 10,
};

const organizationsListReducer = (state = initialState, {
  type, error, data, meta, deletedId,
}) => {
  switch (type) {
    case GET_JURISDICTIONS_REQUEST:
      return { ...state, loading: true };
    case GET_JURISDICTIONS_SUCCESS:
      return {
        ...state,
        data,
        search: meta.search,
        page: meta.current_page,
        lastPage: meta.last_page,
        perPage: meta.per_page,
        order: meta.order,
        sort: meta.sort,
        loading: false,
      };
    case GET_JURISDICTIONS_FAILED:
      return { ...state, loading: false, error };
    case DELETE_JURISDICTION_REQUEST:
      return { ...state, loading: true };
    case DELETE_JURISDICTION_SUCCESS:
      return {
        ...state,
        data: state.data.filter((org) => org.id !== deletedId),
        loading: false,
      };
    case DELETE_JURISDICTION_FAILED:
      return {
        ...state, loading: false, error, data: [...state.data],
      };
    default:
      return state;
  }
};

export default organizationsListReducer;
